module.exports = __webpack_public_path__ + "static/img/shushi-5.50fe5b13.png";